export default {
  'CategoryPanel.Wrapper.TitleInput': ({ category, value }, outlet) => {
    outlet({ category: { ...category, name: value } });
  },
  'CategoryPanel.Wrapper.ItemWrapper.Input': ({ item, itemIndex, category, value }, outlet, internalStateSetter) => {
    let items = [...category.items];
    items[itemIndex] = { ...item, name: value };
    debounce(function () {
      outlet({ category: { ...category, items } });
    }, 1500);
    internalStateSetter({ category: { ...category, items: items }});
  },
  'CategoryPanel.Wrapper.AddNewItem': ({ category }, outlet) => {
    outlet({ category: { ...category, items: [...category.items, { name: '', options: [], area: category.name }] } });
  },
  'CategoryPanel.Wrapper.ItemWrapper.Dropdown': ({ category, item, option, itemIndex }, outlet) => {
    let items = [...category.items];
    let updatedItems = option.is_custom ? { ...item, input_type: option.input_type, options: [option] } : { ...item, input_type: 'options', options: option };
    items[itemIndex] = updatedItems;
    outlet({ category: { ...category, items } });
  },
  'CategoryPanel.Wrapper.ItemWrapper.Delete': ({ category, itemIndex }, outlet) => {
    let items = [...category.items];
    items.splice(itemIndex, 1);
    outlet({ category: { ...category, items } });
  }
};
let timer;
const debounce = function (fn, d) {
  if (timer) {
    clearTimeout(timer);
  }

  timer = setTimeout(fn, d);
}